export default "__VITE_ASSET__KAljy7Gl__"